import React, { Fragment, FunctionComponent, ReactNode, useEffect, useState } from 'react';
import { ApplicationState } from '../../../redux/States';
import { ErrorDispatches } from '../../../redux/Dispatches';
import { ConnectedProps, connect } from 'react-redux';
import { Cell, Row, downloadSheets, generateSheet } from '../../../utils';
import { Row as BSRow, Table, DropdownButton, Dropdown, Col } from 'react-bootstrap';
import { AuthedLayout } from '../../../components';
import { useSemGrade } from '../../../hook';
import apis from '../../../apis';
import { CompareYearClassSightRate, SightSimpleVocIdStatistic, UserInfo } from '../../../model';
import { I18N } from '../../../i18n-raw';
import { toast } from 'react-toastify';



const borderStyle = { color: { rgb: '000000' }, style: 'thin' } as const;
const bottomBorderStyle = {
    bottom: borderStyle,
};

const fullBorderStyle = {
    top: borderStyle,
    bottom: borderStyle,
    left: borderStyle,
    right: borderStyle,
} as const;

const cellAlignStyle = {
    horizontal: 'center',
    vertical: 'center',
} as const;

const mapState = (state: ApplicationState) => ({ ...state.auth });
const mapDispatches = ErrorDispatches;

const connector = connect(mapState, mapDispatches);

type Props = ConnectedProps<typeof connector>;

const useVocId = (): {
    vocId?: number;
    element: ReactNode;
} => {
    const [chooseId, setType] = useState<number>(0);

    return {
        vocId: chooseId,
        element: (
            <DropdownButton
                title={I18N.VocationalHighSchoolSystem?.[chooseId] || '請選擇高職學制'}
                onSelect={(k: string | null) => {
                    if (k == null) return;
                    setType(parseInt(k));
                }}
            >
                {Object.entries(I18N.VocationalHighSchoolSystem).map(([key, value]) => (
                    <Dropdown.Item eventKey={key} key={key}>
                        {value}
                    </Dropdown.Item>
                ))}
            </DropdownButton>
        ),
    };
};
const sightSimple: FunctionComponent<Props> = ({
    user,
    catchErrorForModal,
}) => {
    const { yearSem, element } = useSemGrade();
    const [datas, setDatas] = useState<SightSimpleVocIdStatistic[]>([]);
    const { vocId, element: vocIdElement } = useVocId();
    const [userinfo, setUser] = useState<UserInfo>();
    useEffect(() => {
        if (yearSem) {
            toast
                .promise(
                    apis
                        .getSightSimple(yearSem.year, yearSem.sem, vocId ?? 0)
                        .then(r => {
                            setDatas(r)
                        }),
                    {
                        pending: '資料載入中......',
                        success: '資料載入成功！',
                        error: '資料載入失敗！請查看錯誤資訊。',
                    }
                )
                .catch(catchErrorForModal);

            apis.getUserInfo()
                .then((u) => {
                    setUser(u);
                })
                .catch(catchErrorForModal);

        }
    }, [yearSem?.year, yearSem?.sem, vocId]);

    const gradeBase = datas.reduce((grades, d) => {
        return { ...grades, [d.grade]: [...(grades[d.grade] || []), d] };
    }, {} as Record<number, SightSimpleVocIdStatistic[]>);


    console.log(gradeBase)

    const contentRows: Row[] = Object.entries(gradeBase)
        .flatMap(([gradeStr, records]) => {
            const grade = parseInt(gradeStr);
            const male = records.find((r) => r.sex === 1)!;
            const female = records.find((r) => r.sex === 2)!;
            return sightSummaryToRows(grade, male, female);
        });

    const total = datas.reduce(
        (sum, d) => {
            sum.totalCount += d.totalCount;
            sum.greatCount += d.greatCount;
            sum.notGodCount += d.notGodCount;
            sum.noExamCount += d.noExamCount;
            return sum;
        },
        { totalCount: 0, greatCount: 0, notGodCount: 0, noExamCount: 0 }
    );

    contentRows.unshift({
        cells: [
            { value: "總計", style: { border: fullBorderStyle } },
            { value: "", style: { border: fullBorderStyle } },
            { value: total.totalCount, style: { border: fullBorderStyle } },
            { value: total.greatCount, style: { border: fullBorderStyle } },
            { value: total.notGodCount, style: { border: fullBorderStyle } },
            { value: total.noExamCount, style: { border: fullBorderStyle } },
        ],
    });

    const content: Row[] = [
        {
            cells: [
                {
                    value: '年級',
                    merge: { column: 1 },
                    style: { border: { top: borderStyle, left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
                },
                {
                    value: '性別',
                    merge: { column: 1 },
                    style: { border: { top: borderStyle, left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
                },
                {
                    value: '總計',
                    merge: { column: 1 },
                    style: { border: { top: borderStyle, left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
                },
                {
                    value: '視力正常人數（兩眼均0.9以上）',
                    merge: { column: 1 },
                    style: { border: { top: borderStyle, left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
                },
                {
                    value: '視力不良人數（一眼未達0.9）',
                    merge: { column: 1 },
                    style: { border: { top: borderStyle, left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
                },
                {
                    value: '裸視無法測量',
                    merge: { column: 1 },
                    style: { border: { top: borderStyle, left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
                },
            ]
        },
        ...contentRows,
    ];

    const handlePrint = () => {
        const printWindow = window.open('', '_blank', 'width=1200,height=800');

        if (!printWindow) {
            alert('瀏覽器阻擋了列印視窗，請允許彈出式視窗。');
            return;
        }

        const escapeHtml = (value: unknown): string => {
            return String(value ?? '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        };

        const tableHtml = content
            .map((row) => {
                const cells = row.cells
                    .map((cell) => {
                        if (cell.value === undefined) {
                            return '';
                        }

                        const colSpan = cell.merge?.column
                            ? ` colspan="${cell.merge.column}"`
                            : '';

                        const rowSpan = cell.merge?.row
                            ? ` rowspan="${cell.merge.row}"`
                            : '';

                        return `
                        <td${colSpan}${rowSpan}>
                            ${escapeHtml(cell.value)}
                        </td>
                    `;
                    })
                    .join('');

                return `<tr>${cells}</tr>`;
            })
            .join('');

        const title =
            `${yearSem?.year}學年第${yearSem?.sem}學期_高中職視力統計表` +
            `（科別：${I18N.VocationalHighSchoolSystem[vocId ?? 0]}）`;

        printWindow.document.open();

        printWindow.document.write(`
        <!DOCTYPE html>
        <html lang="zh-Hant">
        <head>
            <meta charset="UTF-8" />
            <title>${escapeHtml(title)}</title>

            <style>
                * {
                    box-sizing: border-box;
                }

                body {
                    margin: 0;
                    padding: 20px;
                    font-family:
                        "Microsoft JhengHei",
                        "Noto Sans TC",
                        Arial,
                        sans-serif;
                    color: #000;
                }

                h1 {
                    margin: 0 0 16px;
                    text-align: center;
                    font-size: 20px;
                }

                table {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: fixed;
                }

                td {
                    border: 1px solid #000;
                    padding: 7px 5px;
                    text-align: center;
                    vertical-align: middle;
                    font-size: 12px;
                    word-break: break-word;
                }

                .footer {
    margin-top: auto;
    padding-top: 16px;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    width: 100%;
}

                @page {
                    size: A4 landscape;
                    margin: 10mm;
                }

                @media print {
                    body {
                        padding: 0;
                    }

                    tr {
                        page-break-inside: avoid;
                    }
                }
            </style>
        </head>

        <body>
            <h1>${escapeHtml(title)}</h1>

            <table>
                <tbody>
                    ${tableHtml}
                </tbody>
            </table>

            <div class="footer">
  <span>承辦人:</span>
  <span>組長:</span>
  <span>主任:</span>
  <span>校長:</span>
</div>

            <script>
                window.onload = function () {
                    window.focus();

                    setTimeout(function () {
                        window.print();
                    }, 300);
                };

                window.onafterprint = function () {
                    window.close();
                };
            </script>
        </body>
        </html>
    `);

        printWindow.document.close();
    };

    return (
        <AuthedLayout>
            <BSRow className="justify-content-between">
                <Col>
                    <BSRow>
                        <Col xs={3} className="mr-2">
                            {element}
                        </Col>
                        <Col xs={3} className="mr-2">
                            {vocIdElement}
                        </Col>
                    </BSRow>
                </Col>
                <DropdownButton
                    id="sight-simple-export"
                    title="匯出"
                    variant="success"
                    disabled={!datas.length}
                >
                    <Dropdown.Item
                        onClick={() => {
                            const workSheet = generateSheet(
                                [
                                    {
                                        cells: [
                                            {
                                                value:
                                                    `${yearSem?.year}學年第${yearSem?.sem}學期_高中職視力統計表` +
                                                    `(科別：${I18N.VocationalHighSchoolSystem[vocId ?? 0]})`,
                                                style: {
                                                    alignment: {
                                                        horizontal: 'left',
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                    ...content,
                                    {
                                        cells: [
                                            {
                                                value:
                                                    '承辦人:　　　　　　　　　　　　　組長:　　　　　　　　　　　　　主任:　　　　　　　　　　　　　　校長:　　　　　　　　　　　　',
                                                style: {
                                                    alignment: {
                                                        horizontal: 'left',
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                ],
                                {
                                    alignment: cellAlignStyle,
                                }
                            );

                            downloadSheets(
                                `${user.schools[user.currentSchool].name}${yearSem?.year}學年第${yearSem?.sem}學期_高中職視力統計表`,
                                userinfo?.exportFileType,
                                {
                                    sheet: workSheet,
                                    name: 'SightMatrix',
                                }
                            );
                        }}
                    >
                        Excel 下載
                    </Dropdown.Item>

                    <Dropdown.Item onClick={handlePrint}>
                        列印
                    </Dropdown.Item>
                </DropdownButton>
            </BSRow>
            <hr />
            <BSRow>
                <Table
                    striped
                    bordered
                    className="text-center"
                    style={{ tableLayout: 'fixed' }}
                >
                    <tbody>
                        {content.map((r, i) => {
                            const cells = r.cells.map((c, j) =>
                                c.value != undefined ? (
                                    <td
                                        colSpan={c.merge?.column}
                                        rowSpan={c.merge?.row}
                                        key={`${i}-${j}`}
                                    >
                                        {c.value}
                                    </td>
                                ) : (
                                    <Fragment key={`${i}-${j}`}></Fragment>
                                )
                            );
                            return <tr key={i}>{cells}</tr>;
                        })}
                    </tbody>
                </Table>
            </BSRow>
        </AuthedLayout>
    );

};

function sightSummaryToRows(
    grade: number,
    male: SightSimpleVocIdStatistic,
    female: SightSimpleVocIdStatistic
): Row[] {
    const total = {
        totalCount: (male?.totalCount ?? 0) + (female?.totalCount ?? 0),
        greatCount: (male?.greatCount ?? 0) + (female?.greatCount ?? 0),
        notGodCount: (male?.notGodCount ?? 0) + (female?.notGodCount ?? 0),
        noExamCount: (male?.noExamCount ?? 0) + (female?.noExamCount ?? 0),
    };

    return [
        {
            cells: [
                {
                    value: `${grade}`,
                    merge: { row: 3 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: "計",
                    style: { border: fullBorderStyle },
                },
                {
                    value: total.totalCount,
                    style: { border: fullBorderStyle },
                },
                {
                    value: total.greatCount,
                    style: { border: fullBorderStyle },
                },
                {
                    value: total.notGodCount,
                    style: { border: fullBorderStyle },
                },
                {
                    value: total.noExamCount,
                    style: { border: fullBorderStyle },
                },
            ],
        },
        // 男
        {
            cells: [
                { style: { border: fullBorderStyle } },
                { value: "男", style: { border: fullBorderStyle } },
                { value: male?.totalCount ?? 0, style: { border: fullBorderStyle } },
                { value: male?.greatCount ?? 0, style: { border: fullBorderStyle } },
                { value: male?.notGodCount ?? 0, style: { border: fullBorderStyle } },
                { value: male?.noExamCount ?? 0, style: { border: fullBorderStyle } },
            ],
        },
        // 女
        {
            cells: [
                { style: { border: fullBorderStyle } },
                { value: "女", style: { border: fullBorderStyle } },
                { value: female?.totalCount ?? 0, style: { border: fullBorderStyle } },
                { value: female?.greatCount ?? 0, style: { border: fullBorderStyle } },
                { value: female?.notGodCount ?? 0, style: { border: fullBorderStyle } },
                { value: female?.noExamCount ?? 0, style: { border: fullBorderStyle } },
            ],
        },
    ];
}

function percent(value: number, denominator: number): number {
    if (!denominator) return 0.00;
    return Number(((value / denominator) * 100).toFixed(2));
}


export const SightSimple = connector(sightSimple);